/** 全局提示：标题「请注意」，样式由 App.vue 与登录成功条一致 */

export const APP_ALERT_EVENT = 'exam-app-alert'
export const APP_CONFIRM_EVENT = 'exam-app-confirm'

let confirmResolve = null

export function appAlert(message) {
  window.dispatchEvent(
    new CustomEvent(APP_ALERT_EVENT, { detail: { message: String(message) } })
  )
}

export function appConfirm(message) {
  return new Promise((resolve) => {
    confirmResolve = resolve
    window.dispatchEvent(
      new CustomEvent(APP_CONFIRM_EVENT, { detail: { message: String(message) } })
    )
  })
}

export function resolveAppConfirm(ok) {
  if (confirmResolve) {
    const r = confirmResolve
    confirmResolve = null
    r(Boolean(ok))
  }
}
